var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: { display: "inline-block" },
      on: {
        "!drop": function ($event) {
          return _vm.onDrop.apply(null, arguments)
        },
      },
    },
    [
      _vm.type === "img"
        ? _c(
            "el-upload",
            {
              class: [
                "logo-uploader",
                _vm.buttonType === "isButton" ? "onlyType" : "",
              ],
              attrs: {
                action: _vm.action,
                headers: _vm.headers,
                "show-file-list": false,
                "on-success": _vm.success,
                "http-request": _vm.toUpload,
                accept: _vm.allowType && _vm.allowType.toString(),
                "on-preview": _vm.handlePreview,
                "before-upload": _vm.beforeUpload,
              },
            },
            [
              _vm.imageUrl && _vm.buttonType !== "isButton"
                ? _c("img", {
                    staticClass: "avatar",
                    style: _vm.styles,
                    attrs: { src: _vm.imageUrl, alt: "" },
                  })
                : _vm._e(),
              !_vm.imageUrl && _vm.buttonType !== "isButton"
                ? _c("i", {
                    staticClass: "el-icon-plus logo-uploader-icon",
                    style: _vm.styles,
                  })
                : _vm._e(),
              _vm.buttonType === "isButton"
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        id: "oneIdButton",
                        size: "medium",
                        type: "primary",
                      },
                    },
                    [_vm._v("上传头像")]
                  )
                : _vm._e(),
              _vm._t("default"),
              _vm._t("text"),
              _vm._t("tip"),
            ],
            2
          )
        : _vm._e(),
      _vm.type === "imgFalseAuto"
        ? _c(
            "el-upload",
            {
              class: [
                "logo-uploader",
                _vm.buttonType === "isButton" ? "onlyType" : "",
              ],
              attrs: {
                "auto-upload": false,
                "on-change": _vm.consoleFL,
                "show-file-list": false,
                "http-request": _vm.toUpload,
                action: "string",
                "on-preview": _vm.handlePreview,
                accept: _vm.allowType && _vm.allowType.toString(),
              },
            },
            [
              _vm.imageUrl && _vm.buttonType !== "isButton"
                ? _c("img", {
                    staticClass: "avatar",
                    style: _vm.styles,
                    attrs: { src: _vm.imageUrl, alt: "" },
                  })
                : _vm._e(),
              !_vm.imageUrl && _vm.buttonType !== "isButton"
                ? _c("i", {
                    staticClass: "el-icon-plus logo-uploader-icon",
                    style: _vm.styles,
                  })
                : _vm._e(),
              _vm.buttonType === "isButton"
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        id: "oneIdButton",
                        size: "medium",
                        type: "primary",
                      },
                    },
                    [_vm._v("上传头像")]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm.type === "file"
        ? _c(
            "el-upload",
            {
              staticClass: "upload-demo",
              attrs: {
                drag: _vm.drag,
                disabled: _vm.disabled,
                "http-request": _vm.toUpload,
                action: _vm.action,
                headers: _vm.headers,
                "on-change": _vm.consoleFL,
                "on-progress": _vm.progress,
                "auto-upload": _vm.autoUpload,
                "file-list": _vm.fileList,
                "show-file-list": _vm.showFileList,
                limit: _vm.limit,
                multiple: _vm.multiple,
                "on-exceed": _vm.exceed,
                accept: _vm.allowType && _vm.allowType.toString(),
                "on-success": _vm.success,
                "before-remove": _vm.handleRemove,
                "before-upload": _vm.beforeUpload,
                "on-preview": _vm.handlePreview,
              },
            },
            [_vm._t("file"), _vm._t("default"), _vm._t("tip")],
            2
          )
        : _vm._e(),
      _c("img", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.img,
            expression: "img",
          },
        ],
        attrs: { src: _vm.img, alt: "" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }